export const getIsConnected = state => state.globalStateReducer.isConnected;
export const getIsMinimize = state => state.globalStateReducer.isMinimize;
export const getOnCall = state => state.globalStateReducer.onCall;
export const getSelectedTab = state => state.globalStateReducer.selectedTab;
export const getState = state => state.globalStateReducer.state;
export const getUserBalance = state => state.globalStateReducer.userBalance;
export const getDynamic = (state, options) => {
  if (options.key) {
    let value = state.globalStateReducer[options.key];
    if (options.debugger) {
      console.log(`[getDynamic] Key :: ${options.key} Value`, value);
    }
    return value;
  } else {
    if (options.debugger) {
      console.log(`[getDynamic] Key Not Define`, options);
    }
    return '';
  }
};



// WEBPACK FOOTER //
// ./src/store/selector/globalState.selector.js